import {
  AfterContentInit,
  Attribute,
  Component, ContentChildren,
  HostBinding,
  Injector,
  Input,
  Optional, QueryList,
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { APPLY_STYLES_TYPE,DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import { find, includes, isEmpty, noop} from "lodash-es";
import {TabPaneComponent} from "./tab-pane/tab-pane.component";
import {WmsTranscludeDirective} from "../../page/wms-transclude/wms-transclude.directive";
import {runtimeEventManager, addClass, removeClass, createArrayFrom} from "@wm/core";

const DEFAULT_CLS = 'app-tabs clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-tabs',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmTabs]',
  template: `<div class="app-tabs">
  <ul class="nav nav-tabs" [ngClass]="{'nav-stacked': vertical, 'nav-justified': justified}" role="tablist">
    <li class="tab-header" *ngFor="let pane of panes; let i=index;" [attr.data-paneid]="pane.widgetId"   [attr.data-tab-id]="i"  [ngClass]="{'active': pane.isActive}"
        [hidden]="!pane.show" (click)="pane.select($event,pane); " role="tab">
      <a href="javascript:void(0);" role="button" [attr.icon-position]="iconposition" [attr.aria-label]="pane.title" [attr.title]="pane.title" [tabindex]="pane.tabindex" [attr.aria-controls]="pane.name">
        <div class="tab-heading">
          <i [ngClass]="['app-icon', pane.paneicon]" *ngIf="pane.paneicon"></i>
          <span [textContent]="pane.title"></span>
          <span *ngIf="pane.badgevalue" class="app-label badge label-{{pane.badgetype}}" [textContent]="pane.badgevalue"></span>
        </div>
      </a>
    </li>
  </ul>
  <div class="tab-content" [ngClass]="{'tab-stacked': vertical, 'tab-justified': justified}" wmsTransclude>
    <ng-content ngProjectAs="div[wmTabPane]"></ng-content>
  </div>
  <select *ngIf="showlist" class="tabs-list" (change)="onTabSelection($event.target)" title="Select a Tab"><option *ngFor="let pane of panes" [value]="pane.title" [innerHTML]="pane.title"></option></select></div>`,
  providers: [
    provideAsWidgetRef(TabsComponent),TabPaneComponent],
  exportAs: 'wmTabs',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  styles: []
})
export class TabsComponent extends StylableComponent implements AfterContentInit {
  static initializeProps = register('wm-tabs');

  public defaultpaneindex: number
  public transition: string;
  public tabsposition: string;
  public statehandler: any;
  public vertical: boolean;
  public justified: boolean;
  private activeTab: TabPaneComponent;
  private readonly promiseResolverFn: Function;
  private _oldPaneIndex: number;
  private dynamicPaneIndex:any;
  public dynamicTabs:any;
  public fieldDefs:any;
  public type:string;
  public nodatamessage:any;
  private dynamicComponentProvider: any;
  tabs:any[]=[];
  @Input() showlist: boolean = true;

  @HostBinding('attr.icon-position') iconposition: string = '';

  @ContentChildren(TabPaneComponent) panes: QueryList<TabPaneComponent>;


  constructor(inj: Injector,
              @Optional() viewParent: Parent,
              @Attribute('transition') _transition: string,
              @Attribute('tabsposition') _tabsPosition: string, ) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
    let resolveFn: Function = noop;
    this.transition = _transition;
    this.tabsposition = _tabsPosition;
    this.dynamicTabs = [];
    this.dynamicPaneIndex = 0;
    this.promiseResolverFn = resolveFn;
    this.dynamicComponentProvider = runtimeEventManager.getService('dynamicComponentProvider');


  }


  renderTemplate(type: string) {
    let markup: string;
    if (type === 'dynamic') {
      markup = '<wm-tabs type="dynamic" statehandler="URL"><wm-repeat-template><wm-tabpane title="Tab title"></wm-tabpane></wm-repeat-template></wm-tabs>';
    } else {
      markup = '<wm-tabs type="static" statehandler="URL"><wm-tabpane title="Tab title"></wm-tabpane><wm-tabpane title="Tab title"></wm-tabpane><wm-tabpane title="Tab title"></wm-tabpane></wm-tabs>';
    }

    runtimeEventManager.emit('canvas-switch-template', {widgetId: this.widgetId, markup: markup});
  }

  setProperties(nv: string, ov?: string) {
    if (nv && ov && nv !== ov) {
      this.renderTemplate(nv);
    }
    this.widgetProps['addchild'].show = nv !== 'dynamic';
    this.widgetProps['nodatamessage'].show = nv === 'dynamic';
    this.widgetProps['dataset'].show = nv === 'dynamic';
  }

  public notifyChange(paneRef: TabPaneComponent | any, evt: any) {
    let headerElement;
    // invoke deselect event callback on the preset active tab
    if (!isEmpty(this.activeTab)) {
      this.activeTab.deselect();
    }

    this.activeTab = paneRef.widget;
    const newPaneIndex = this.getPaneIndexByRef(paneRef);
      this.defaultpaneindex = this.getPaneIndexByRef(paneRef);

    this._oldPaneIndex = newPaneIndex;

    if (evt) {
      headerElement = $(evt.target as HTMLElement).closest('li.tab-header');
    }
    if (!evt || !headerElement || !headerElement.length) {
      headerElement = this.nativeElement.querySelector(`li[data-paneid=${paneRef.widgetId}]`);
    }

  }

  ngAfterContentInit() {
    this.promiseResolverFn();
    this.setTabsPosition(this.tabsposition);
    this.panes.changes.subscribe(slides => {
      if (this.panes.length) {
        this.selectDefaultPaneByIndex(this.defaultpaneindex || 0);
      }
    })
  }

  // when a tab is selected using tabslist dropdown
  onTabSelection = (target: any) => {
    this.getPaneRefByIndex(target.selectedIndex).select();
  }

  registerHeader(tabScope: any) {
    if (this.panes && !includes(this.panes['_results'], tabScope)) {
      this.panes.reset([...this.panes.toArray(), tabScope])
    }
    let boundTitles = this.nativeElement.getAttribute('data-evaluated-title');
    if (boundTitles) {
      boundTitles.split(' ').forEach((paneid: string) => {
        this.$element.find('ul > li[data-paneid="' + paneid + '"]').attr('data-evaluated-title', '');
      })
    }
  }

  protected override onPropertyChange(this: any, key: string, nv: any, ov?: any) {

    if (key === 'defaultpaneindex') {
      this.defaultpaneindex = nv;
    } else if (key === 'dataset') {
      this.onDataChange(nv);
    } else if (key === 'type') {
      this.setProperties(nv, ov);
    } else if (key === 'tabsposition') {
      this.setTabsPosition(nv)
    } else if (key === 'statehandler') {
        setTimeout(() => this.selectDefaultPaneByIndex(this.defaultpaneindex || 0), 20);
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  private onDataChange(newVal: any) {
    this.fieldDefs = createArrayFrom(newVal);
    setTimeout(() => this.selectDefaultPaneByIndex(this.defaultpaneindex || 0));
  }

  private selectDefaultPaneByIndex(index: number) {
    if (!this.isValidPaneIndex(index)) {
      return;
    }

    let paneRef = this.getPaneRefByIndex(index);
    if (paneRef) {
      paneRef.select();
    }
  }

  private isValidPaneIndex(index: number): boolean {
    return (index >= 0 && index < this.panes?.length);
  }

  private getPaneRefByIndex(index: number): TabPaneComponent {
    return this.panes?.toArray()[index];
  }

  private getSelectableTabAfterIndex(index: number): any {
    for (let i = index + 1; i < this.panes?.length; i++) {
      const pane = this.getPaneRefByIndex(i);
      return pane;
    }
  }

  private getPaneIndexByRef(paneRef: TabPaneComponent): number {
    return this.panes.toArray().indexOf(paneRef);
  }

  private setTabsPosition(tabsPosition:string) {
    const ul: JQuery<HTMLElement> = $(this.nativeElement).find('>ul.nav-tabs');
    removeClass(this.nativeElement, 'inverted');
    if (tabsPosition === 'bottom' || tabsPosition === 'right') {
      addClass(this.nativeElement, 'inverted');
      $(this.nativeElement).append(ul)
    } else {
      $(this.nativeElement).prepend(ul)
    }
    this.vertical = (tabsPosition === 'left' || tabsPosition === 'right');
  }

  onTabPaneDestroyed(component: TabPaneComponent) {
    // Find the index of the destroyed component in the QueryList
    const index = this.panes.toArray().indexOf(component);

    if (index !== -1) {
      // Remove the item from the items array at the corresponding index
      (this.panes as any)._results.splice(index, 1);
    }
  }

}

